import { render, staticRenderFns } from "./Penghasilan.html?vue&type=template&id=3ff3d81a&scoped=true&"
import script from "./Penghasilan.js?vue&type=script&lang=js&"
export * from "./Penghasilan.js?vue&type=script&lang=js&"
import style0 from "./Penghasilan.scss?vue&type=style&index=0&id=3ff3d81a&lang=scss&scoped=true&"
import style1 from "./Penghasilan.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3d81a",
  null
  
)

export default component.exports